import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-microscope',
  templateUrl: './microscope.component.html',
  styleUrls: ['./microscope.component.scss']
})
export class MicroscopeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
